var _defs, _rect, _rect2, _line, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarToggle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sidebarToggleClip"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 4.25
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.25,
    y: 2.25,
    width: 19.5,
    height: 19.5,
    rx: 4.75,
    stroke: "var(--color-icon-sidebar-collapse-stroke, black)",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "panel-fill",
    clipPath: "url(#sidebarToggleClip)",
    x: 15.5,
    y: 0,
    width: 12,
    height: 24,
    fill: "var(--color-icon-sidebar-collapse-stroke, black)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "panel-divider",
    x1: 15.5,
    y1: 4.5,
    x2: 15.5,
    y2: 19.5,
    stroke: "var(--color-icon-sidebar-collapse-stroke, black)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "chevron-expand",
    d: "M7.75 9.25L10.75 12.25L7.75 15.25",
    stroke: "var(--color-icon-sidebar-collapse-stroke, black)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "chevron-collapse",
    d: "M11.25 9.25L8.25 12.25L11.25 15.25",
    stroke: "var(--color-icon-sidebar-collapse-stroke, black)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarToggle);
export default __webpack_public_path__ + "static/media/SidebarToggle.18bf2bb6716c3e5fd2bdefc0a6bb2c91.svg";
export { ForwardRef as ReactComponent };